module.exports = __webpack_public_path__ + "static/Walter-b1f7bd827349f94b5b1e92fd4ed6a73a.jpeg";